import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageEntry} from '../../../../../core/page/page.entry';
import {FuellingConfigEntry, FuellingConfigFilter, FuellingConfigUpdateForm} from './model/fuelling-config.entry';
import {Pageable} from '../../../../../core/page/pageable';
import {PageRestUtils} from '../../../../../core/page/commons/page-rest.utils';
import {CheapCountriesConfig} from "./model/cheap-countries-config";

@Injectable({providedIn: 'root'})
export class FuellingReplanningConfigsService {

  constructor(private http: HttpClient) {
  }

  public fetch(pageable: Pageable, filter: FuellingConfigFilter): Observable<PageEntry<FuellingConfigEntry>> {
    let params = PageRestUtils.appendPageableParams(pageable, new HttpParams());
    if (filter.vehicleGroup) {
      params = params.append('vehicleGroup', filter.vehicleGroup);
    }
    params = params.append('vehicle', filter.vehicle);
    if (filter.autoReplanning != null) {
      params = params.append('autoReplanning', filter.autoReplanning);
    }
    if (filter.replanningSuggestion != null) {
      params = params.append('replanningSuggestion', filter.replanningSuggestion);
    }
    return this.http.get<PageEntry<FuellingConfigEntry>>('/api/fuelling-config', {params});
  }

  public update(filter: FuellingConfigFilter, form: FuellingConfigUpdateForm): Observable<void> {
    let params = new HttpParams();
    if (filter.vehicleGroup) {
      params = params.append('vehicleGroup', filter.vehicleGroup);
    }
    params = params.append('vehicle', filter.vehicle);
    if (filter.autoReplanning != null) {
      params = params.append('autoReplanning', filter.autoReplanning);
    }
    if (filter.replanningSuggestion != null) {
      params = params.append('replanningSuggestion', filter.replanningSuggestion);
    }
    return this.http.post<void>('/api/fuelling-config/update', form, {params});
  }

  public updateSingle(configId: number, form: FuellingConfigUpdateForm): Observable<FuellingConfigEntry> {
    return this.http.post<FuellingConfigEntry>('/api/fuelling-config/update/' + configId, form);
  }

  public getCheapCountriesConfig(): Observable<CheapCountriesConfig> {
    return this.http.get<CheapCountriesConfig>('/api/cheap-countries-config');
  }

  public saveCheapCountriesConfig(config: CheapCountriesConfig): Observable<void> {
    return this.http.post<void>('/api/cheap-countries-config', config);
  }

  public isAutomaticReplanning(vehicleId: number): Observable<boolean> {
    return this.http.get<boolean>('/api/fuelling-config/is-automatic-replanning/' + vehicleId);
  }
}
